var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSort(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 10,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.644 5.804h6.373c.573 0 .86.65.455 1.03L4.286 9.823a.67.67 0 01-.908 0L.19 6.833c-.404-.379-.118-1.03.455-1.03zm6.828-2.638L4.286.177a.67.67 0 00-.908 0L.19 3.167c-.404.379-.118 1.03.455 1.03h6.373c.573 0 .86-.651.455-1.03z",
    fill: "#212121"
  })));
}
export default SvgSort;